import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * ERV Icon Style01 - Air Flow icon (clean air waves)
 * 空氣流通圖示 - 簡潔的氣流波紋
 */
export const Style01_Air: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
  animated = false 
}) => {
  const sizeInPx = getSizeInPixels(size);
  const primaryColor = isOn ? '#2dd4bf' : '#64748b'; // teal-400 : slate-500
  const secondaryColor = isOn ? '#14b8a6' : '#475569'; // teal-500 : slate-600
  
  return (
    <svg
      viewBox="0 0 24 24"
      width={sizeInPx}
      height={sizeInPx}
      fill="none"
      className={`${className} ${animated && isOn ? 'animate-pulse' : ''}`}
    >
      {/* Air flow waves */}
      <path
        d="M4 8C4 8 6 6 9 6C12 6 14 9 17 9C20 9 22 7 22 7"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12C4 12 6 10 9 10C12 10 14 13 17 13C20 13 22 11 22 11"
        stroke={secondaryColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 16C4 16 6 14 9 14C12 14 14 17 17 17C20 17 22 15 22 15"
        stroke={primaryColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Style01_Air;
